import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IconStrokeWidth } from "../../../constants/Variables";

const Sidebar = ({ setIsSideBarClosed, active }) => {
  const Nav = useNavigate();
  const [close, setClose] = useState(() => {
    const storedCloseValue = localStorage.getItem("close");
    return storedCloseValue ? JSON.parse(storedCloseValue) : false;
  });
  useEffect(() => {
    setIsSideBarClosed(close);
    localStorage.setItem("close", JSON.stringify(close));
  }, [close]);
  return (
    <>
      <section
        className={`${close ? "md:w-[77px]" : "md:w-[200px] md:max-w-[200px]"}
    border-e md:border-t-none border-t border-primary-50 dark:border-accent-700 bg-white dark:bg-accent-900 z-10 box-border fixed md:top-0 md:bottom-0 md:pt-[83px] md:px-16px md:pb-16px px-20px md:py-16px py-10px duration-300 bottom-0 right-0 left-0`}
      >
        <div className="h-full flex md:flex-col flex-row justify-between">
          <div
            onClick={() => setClose(!close)}
            className="absolute bottom-[15%] z-[999] max-w-[40px] max-h-[40px] w-full h-full right-[-20px] rounded-full shadow-md md:flex hidden"
          >
            <div
              className={`flex bg-white dark:bg-accent-900 border dark:border-accent-600 border-primary-100 aspect-square rounded-full cursor-pointer ${
                close ? "" : "rotate-180"
              }`}
            >
              <span className="m-auto">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_105_10918"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  >
                    <rect width="24" height="24" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_105_10918)">
                    <path
                      d="M9.4 18L8 16.6L12.6 12L8 7.4L9.4 6L15.4 12L9.4 18Z"
                      className="fill-accent-700 dark:fill-accent-300"
                    />
                  </g>
                </svg>
              </span>
            </div>
          </div>
          <div className="sidebar-top flex md:flex-col flex-row items-center w-full">
            <div className="create-new | md:pb-16px md:border-b p-0 h-fit md:w-full w-[64px] md:pe-0 pe-20px md:border-e-0 border-e border-accent-50 dark:border-accent-600">
              <button
                className="create-link | p-10px flex whitespace-nowrap justify-center text-base text-white md:w-full w-[44px] h-[44px] overflow-hidden border-none bg-primary-500 rounded-lg font-medium shadow-md duration-300 hover:opacity-90"
                onClick={() => Nav("/new")}
              >
                {close ? (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_108_11050"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="24"
                      height="24"
                    >
                      <rect width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_108_11050)">
                      <path
                        d="M11 19V13H5V11H11V5H13V11H19V13H13V19H11Z"
                        fill="white"
                      />
                    </g>
                  </svg>
                ) : (
                  <span>
                    <span className="md:block hidden"> Create link</span>
                    <span className="block md:hidden text-xl leading-none">
                      +
                    </span>
                  </span>
                )}
              </button>
            </div>
            <div className="actions | flex gap-10px w-full md:pt-16px md:flex-col flex-row md:justify-normal justify-around ">
              <div onClick={() => Nav("/dashboard")} className="">
                <div
                  className={`${
                    active === "/dashboard"
                      ? "text-primary-500 bg-primary-50 dark:bg-accent-600"
                      : "text-accent-400 dark:text-primary-600"
                  }
               flex overflow-hidden whitespace-nowrap gap-10px font-medium items-center ${
                 close ? "p-10px" : "py-10px px-20px"
               } rounded-lg duration-300 cursor-pointer relative hover:bg-primary-50 dark:hover:bg-accent-700  ${
                    close
                      ? ""
                      : active === "/dashboard"
                      ? "md:before:w-[3px] md:before:h-[22px] md:before:rounded-lg md:before:bg-primary-500 md:before:absolute md:before:left-[4px]"
                      : ""
                  }`}
                >
                  <span>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 13V17M16 11V17M12 7V17M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z"
                        className={`${
                          active === "/dashboard"
                            ? "stroke-primary-500"
                            : "stroke-accent-400 dark:stroke-primary-600"
                        } `}
                        strokeWidth={IconStrokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span
                    className={`${
                      close ? " hidden" : " block"
                    } md:block hidden`}
                  >
                    Dashboard
                  </span>
                </div>
              </div>
              <div onClick={() => Nav("/links")}>
                <div
                  className={`${
                    active === "/links"
                      ? "text-primary-500 bg-primary-50 dark:bg-accent-600"
                      : "text-accent-400 dark:text-primary-600"
                  }
               flex overflow-hidden whitespace-nowrap gap-10px font-medium items-center ${
                 close ? "p-10px" : "py-10px px-20px"
               } rounded-lg duration-300 cursor-pointer relative hover:bg-primary-50 dark:hover:bg-accent-700  ${
                    close
                      ? ""
                      : active === "/links"
                      ? "md:before:w-[3px] md:before:h-[22px] md:before:rounded-lg md:before:bg-primary-500 md:before:absolute md:before:left-[4px]"
                      : ""
                  }`}
                >
                  <span>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 17H7C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7H9M15 17H17C19.7614 17 22 14.7614 22 12C22 9.23858 19.7614 7 17 7H15M7 12L17 12"
                        className={`${
                          active === "/links"
                            ? "stroke-primary-500"
                            : "stroke-accent-400 dark:stroke-primary-600"
                        } `}
                        strokeWidth={IconStrokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span
                    className={`${
                      close ? " hidden" : " block"
                    } md:block hidden`}
                  >
                    Links
                  </span>
                </div>
              </div>
              <div onClick={() => Nav("/qrcodes")}>
                <div
                  className={`${
                    active === "/qrcodes"
                      ? "text-primary-500 bg-primary-50 dark:bg-accent-600"
                      : "text-accent-400 dark:text-primary-600"
                  }
               flex overflow-hidden whitespace-nowrap gap-10px font-medium items-center ${
                 close ? "p-10px" : "py-10px px-20px"
               } rounded-lg duration-300 cursor-pointer relative hover:bg-primary-50 dark:hover:bg-accent-700  ${
                    close
                      ? ""
                      : active === "/qrcodes"
                      ? "md:before:w-[3px] md:before:h-[22px] md:before:rounded-lg md:before:bg-primary-500 md:before:absolute md:before:left-[4px]"
                      : ""
                  }`}
                >
                  <span>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 12H12V17M3.01 12H3M8.01 17H8M12.01 21H12M21.01 12H21M3 17H4.5M15.5 12H17.5M3 21H8M12 2V8M17.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V17.6C21 17.0399 21 16.7599 20.891 16.546C20.7951 16.3578 20.6422 16.2049 20.454 16.109C20.2401 16 19.9601 16 19.4 16H17.6C17.0399 16 16.7599 16 16.546 16.109C16.3578 16.2049 16.2049 16.3578 16.109 16.546C16 16.7599 16 17.0399 16 17.6V19.4C16 19.9601 16 20.2401 16.109 20.454C16.2049 20.6422 16.3578 20.7951 16.546 20.891C16.7599 21 17.0399 21 17.6 21ZM17.6 8H19.4C19.9601 8 20.2401 8 20.454 7.89101C20.6422 7.79513 20.7951 7.64215 20.891 7.45399C21 7.24008 21 6.96005 21 6.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3H17.6C17.0399 3 16.7599 3 16.546 3.10899C16.3578 3.20487 16.2049 3.35785 16.109 3.54601C16 3.75992 16 4.03995 16 4.6V6.4C16 6.96005 16 7.24008 16.109 7.45399C16.2049 7.64215 16.3578 7.79513 16.546 7.89101C16.7599 8 17.0399 8 17.6 8ZM4.6 8H6.4C6.96005 8 7.24008 8 7.45399 7.89101C7.64215 7.79513 7.79513 7.64215 7.89101 7.45399C8 7.24008 8 6.96005 8 6.4V4.6C8 4.03995 8 3.75992 7.89101 3.54601C7.79513 3.35785 7.64215 3.20487 7.45399 3.10899C7.24008 3 6.96005 3 6.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V6.4C3 6.96005 3 7.24008 3.10899 7.45399C3.20487 7.64215 3.35785 7.79513 3.54601 7.89101C3.75992 8 4.03995 8 4.6 8Z"
                        className={`${
                          active === "/qrcodes"
                            ? "stroke-primary-500"
                            : "stroke-accent-400 dark:stroke-primary-600"
                        } `}
                        strokeWidth={IconStrokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span
                    className={`${
                      close ? " hidden" : " block"
                    } md:block hidden`}
                  >
                    QR Codes
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="sidebar-bottom | md:border-t md:border-accent-50 dark:border-accent-600 md:block hidden">
            <div className="actions | flex flex-col gap-10px w-full md:pt-16px">
              <div onClick={() => Nav("/settings")}>
                <div
                  className={`${
                    active === "/settings"
                      ? "text-primary-500 bg-primary-50 dark:bg-accent-600"
                      : "text-accent-400 dark:text-primary-600"
                  }
               flex overflow-hidden whitespace-nowrap gap-10px font-medium items-center ${
                 close ? "p-10px" : "py-10px px-20px"
               } rounded-lg duration-300 cursor-pointer relative hover:bg-primary-50 dark:hover:bg-accent-700  ${
                    close
                      ? ""
                      : active === "/settings"
                      ? "md:before:w-[3px] md:before:h-[22px] md:before:rounded-lg md:before:bg-primary-500 md:before:absolute md:before:left-[4px]"
                      : ""
                  }`}
                >
                  <span>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                        className={`${
                          active === "/settings"
                            ? "stroke-primary-500"
                            : "stroke-accent-400 dark:stroke-primary-600"
                        } `}
                        strokeWidth={IconStrokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M18.7273 14.7273C18.6063 15.0015 18.5702 15.3056 18.6236 15.6005C18.6771 15.8954 18.8177 16.1676 19.0273 16.3818L19.0818 16.4364C19.2509 16.6052 19.385 16.8057 19.4765 17.0265C19.568 17.2472 19.6151 17.4838 19.6151 17.7227C19.6151 17.9617 19.568 18.1983 19.4765 18.419C19.385 18.6397 19.2509 18.8402 19.0818 19.0091C18.913 19.1781 18.7124 19.3122 18.4917 19.4037C18.271 19.4952 18.0344 19.5423 17.7955 19.5423C17.5565 19.5423 17.3199 19.4952 17.0992 19.4037C16.8785 19.3122 16.678 19.1781 16.5091 19.0091L16.4545 18.9545C16.2403 18.745 15.9682 18.6044 15.6733 18.5509C15.3784 18.4974 15.0742 18.5335 14.8 18.6545C14.5311 18.7698 14.3018 18.9611 14.1403 19.205C13.9788 19.4489 13.8921 19.7347 13.8909 20.0273V20.1818C13.8909 20.664 13.6994 21.1265 13.3584 21.4675C13.0174 21.8084 12.5549 22 12.0727 22C11.5905 22 11.1281 21.8084 10.7871 21.4675C10.4461 21.1265 10.2545 20.664 10.2545 20.1818V20.1C10.2475 19.7991 10.1501 19.5073 9.97501 19.2625C9.79991 19.0176 9.55521 18.8312 9.27273 18.7273C8.99853 18.6063 8.69437 18.5702 8.39947 18.6236C8.10456 18.6771 7.83244 18.8177 7.61818 19.0273L7.56364 19.0818C7.39478 19.2509 7.19425 19.385 6.97353 19.4765C6.7528 19.568 6.51621 19.6151 6.27727 19.6151C6.03834 19.6151 5.80174 19.568 5.58102 19.4765C5.36029 19.385 5.15977 19.2509 4.99091 19.0818C4.82186 18.913 4.68775 18.7124 4.59626 18.4917C4.50476 18.271 4.45766 18.0344 4.45766 17.7955C4.45766 17.5565 4.50476 17.3199 4.59626 17.0992C4.68775 16.8785 4.82186 16.678 4.99091 16.5091L5.04545 16.4545C5.25503 16.2403 5.39562 15.9682 5.4491 15.6733C5.50257 15.3784 5.46647 15.0742 5.34545 14.8C5.23022 14.5311 5.03887 14.3018 4.79497 14.1403C4.55107 13.9788 4.26526 13.8921 3.97273 13.8909H3.81818C3.33597 13.8909 2.87351 13.6994 2.53253 13.3584C2.19156 13.0174 2 12.5549 2 12.0727C2 11.5905 2.19156 11.1281 2.53253 10.7871C2.87351 10.4461 3.33597 10.2545 3.81818 10.2545H3.9C4.2009 10.2475 4.49273 10.1501 4.73754 9.97501C4.98236 9.79991 5.16883 9.55521 5.27273 9.27273C5.39374 8.99853 5.42984 8.69437 5.37637 8.39947C5.3229 8.10456 5.18231 7.83244 4.97273 7.61818L4.91818 7.56364C4.74913 7.39478 4.61503 7.19425 4.52353 6.97353C4.43203 6.7528 4.38493 6.51621 4.38493 6.27727C4.38493 6.03834 4.43203 5.80174 4.52353 5.58102C4.61503 5.36029 4.74913 5.15977 4.91818 4.99091C5.08704 4.82186 5.28757 4.68775 5.50829 4.59626C5.72901 4.50476 5.96561 4.45766 6.20455 4.45766C6.44348 4.45766 6.68008 4.50476 6.9008 4.59626C7.12152 4.68775 7.32205 4.82186 7.49091 4.99091L7.54545 5.04545C7.75971 5.25503 8.03183 5.39562 8.32674 5.4491C8.62164 5.50257 8.9258 5.46647 9.2 5.34545H9.27273C9.54161 5.23022 9.77093 5.03887 9.93245 4.79497C10.094 4.55107 10.1807 4.26526 10.1818 3.97273V3.81818C10.1818 3.33597 10.3734 2.87351 10.7144 2.53253C11.0553 2.19156 11.5178 2 12 2C12.4822 2 12.9447 2.19156 13.2856 2.53253C13.6266 2.87351 13.8182 3.33597 13.8182 3.81818V3.9C13.8193 4.19253 13.906 4.47834 14.0676 4.72224C14.2291 4.96614 14.4584 5.15749 14.7273 5.27273C15.0015 5.39374 15.3056 5.42984 15.6005 5.37637C15.8954 5.3229 16.1676 5.18231 16.3818 4.97273L16.4364 4.91818C16.6052 4.74913 16.8057 4.61503 17.0265 4.52353C17.2472 4.43203 17.4838 4.38493 17.7227 4.38493C17.9617 4.38493 18.1983 4.43203 18.419 4.52353C18.6397 4.61503 18.8402 4.74913 19.0091 4.91818C19.1781 5.08704 19.3122 5.28757 19.4037 5.50829C19.4952 5.72901 19.5423 5.96561 19.5423 6.20455C19.5423 6.44348 19.4952 6.68008 19.4037 6.9008C19.3122 7.12152 19.1781 7.32205 19.0091 7.49091L18.9545 7.54545C18.745 7.75971 18.6044 8.03183 18.5509 8.32674C18.4974 8.62164 18.5335 8.9258 18.6545 9.2V9.27273C18.7698 9.54161 18.9611 9.77093 19.205 9.93245C19.4489 10.094 19.7347 10.1807 20.0273 10.1818H20.1818C20.664 10.1818 21.1265 10.3734 21.4675 10.7144C21.8084 11.0553 22 11.5178 22 12C22 12.4822 21.8084 12.9447 21.4675 13.2856C21.1265 13.6266 20.664 13.8182 20.1818 13.8182H20.1C19.8075 13.8193 19.5217 13.906 19.2778 14.0676C19.0339 14.2291 18.8425 14.4584 18.7273 14.7273Z"
                        className={`${
                          active === "/settings"
                            ? "stroke-primary-500"
                            : "stroke-accent-400 dark:stroke-primary-600"
                        } `}
                        strokeWidth={IconStrokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span className={`${close ? " hidden" : " block"}`}>
                    Settings
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Sidebar;
